import { accountStatus } from "../../supabase/functions/_shared/admin-user-controls";

export type AdminUser = {
  id: string;
  email: string;
  created_at: string;
  last_sign_in_at: string | null;
  email_confirmed_at: string | null;
  banned_until: string | null;
  can_manage_lock?: boolean;
  is_administrator?: boolean;
  can_manage_administrator?: boolean;
  quota: {
    period_start: string; quota_seconds: number; reserved_seconds: number;
    consumed_seconds: number; remaining_seconds: number; updated_at: string | null;
  };
};

export const USER_COLUMNS = [
  { key: "email", label: "Email" }, { key: "status", label: "Status" },
  { key: "created", label: "Created" }, { key: "last_sign_in", label: "Last sign-in" },
  { key: "used", label: "Used" }, { key: "reserved", label: "Reserved" },
  { key: "remaining", label: "Remaining" },
] as const;
export type UserSortKey = typeof USER_COLUMNS[number]["key"];

export function userSortValue(user: AdminUser, key: UserSortKey): string | number | null {
  switch (key) {
    case "email": return user.email;
    case "status": return accountStatus(user);
    case "created": return Date.parse(user.created_at);
    case "last_sign_in": return user.last_sign_in_at ? Date.parse(user.last_sign_in_at) : null;
    case "used": return user.quota.consumed_seconds;
    case "reserved": return user.quota.reserved_seconds;
    case "remaining": return user.quota.remaining_seconds;
  }
}
